import { resolveColorsPalette } from "./../../wix-rich-content-common";
import { DEFAULT_PALETTE } from "../defaults";
const resolveColors = (args) => resolveColorsPalette(
  [
    ...DEFAULT_PALETTE,
    ...args.colors ? Object.values(args.colors) : [],
    ...args.getColorFn?.() ?? []
  ],
  args.currentColor,
  57
);
export {
  resolveColors
};
//# sourceMappingURL=resolve-colors.js.map
